import React, { Component } from 'react'
import { Switch, Route, withRouter, Redirect } from 'react-router-dom'
import * as Sentry from '@sentry/browser'

import {
  Accounts,
  CaseList,
  Communications,
  CreditApplication,
  CreditApplications,
  CreditList,
  Dashboard,
  Deduction,
  Deductions,
  Division,
  DownloadList,
  Files,
  FileProcess,
  FilesUpload,
  Home,
  Identity,
  IdentityList,
  ImpactReport,
  InsuranceList,
  InvestmentList,
  LoanApplication,
  Metrics,
  ObjectRedirect,
  Payment,
  Payments,
  PayrollRun,
  PayrollRunList,
  Request,
  Requests,
  Search,
  TaskList,
  Transaction,
  Transactions,
  WhatsAppMessage,
  WithdrawalList,
  WithdrawalBatchList,
  WithdrawalBatchDetail,
  Workflow,
  WorkflowList
} from './'

import {
  PrivateRoute,
  PrivateRouteInternal,
  PrivateRouteWithErrorBoundary,
  PrivateRouteInternalWithErrorBoundary,
  PrivateRouteWithPermission
} from '../auth'

import {
  getNodeTypeFromBase64Id
} from '../utils'

const FourOhFour = ({ pathName }) => {
  Sentry.captureMessage(`Page not found for ${pathName}`, 'error')
  return (
    <div>
      <h2>Page Not Found</h2>
    </div>
  )
}

export class Main extends Component {
  state = {
    query: null,
    search: false
  }

  render() {
    return (
      <div className='stage-main slds-size_1-of-1' style={{ position: 'absolute', top: 80 }}>
        <Switch>
          <PrivateRoute exact path='/os' component={Home}/>
          <PrivateRouteInternal exact path='/os/people' component={IdentityList} />
          <PrivateRouteInternal exact path='/os/people/employees' component={IdentityList} />
          <PrivateRouteInternal exact path='/os/identity/:identityId/divisions/:divisionId' component={Division} />
          <PrivateRouteInternal path='/os/identity/:identityId' component={Identity} />
          <PrivateRouteInternal exact path='/os/people/employers' component={IdentityList} />
          <PrivateRouteInternal exact path='/os/people/contacts' component={IdentityList} />
          <PrivateRouteInternal exact path='/os/products/credit/applications' component={CreditApplications} />
          <PrivateRouteInternal
            exact
            path='/os/products/credit/applications/:loanApplication'
            render={(props) => {
              let isCreditApplicationNode = getNodeTypeFromBase64Id(props.match.params.loanApplication) === 'CreditApplicationNode'
              if (isCreditApplicationNode) {
                return <CreditApplication {...props} />
              } else {
                return <LoanApplication {...props} />
              }
            }}
          />
          <PrivateRouteInternal exact path='/os/products/credit' component={CreditList} />
          <PrivateRouteInternal exact path='/os/products/investments' component={InvestmentList} />
          <PrivateRouteInternal exact path='/os/products/withdrawals' component={WithdrawalList} />
          <PrivateRouteInternal exact path='/os/products/withdrawalbatches' component={WithdrawalBatchList} />
          <PrivateRouteInternal exact path='/os/products/withdrawalbatches/:id' component={WithdrawalBatchDetail} />
          <PrivateRouteInternal exact path='/os/products/insurance' component={InsuranceList} />
          <PrivateRouteInternal exact path='/os/cases' component={CaseList} />
          <PrivateRouteInternal exact path='/os/cases/:id' component={ObjectRedirect} />
          <PrivateRouteInternal exact path='/os/operations/general/files/upload' component={FilesUpload} />
          <PrivateRouteInternal exact path='/os/operations/general/files/:file' component={FileProcess} />
          <PrivateRouteInternal exact path='/os/operations/general/files' component={Files} />
          <PrivateRouteInternal exact path='/os/operations/general/tasks' component={TaskList} />
          <PrivateRouteInternalWithErrorBoundary exact path='/os/operations/general/requests/:id' component={Request} />
          <PrivateRouteInternal exact path='/os/operations/general/requests' component={Requests} />
          <PrivateRouteWithErrorBoundary exact path='/os/operations/general/deductions/open/:deduction' component={Deduction} />  {/* route not 'exact' because expecting urls to reflect search/filter params */}
          <PrivateRouteWithErrorBoundary exact path='/os/operations/general/deductions/history/:deduction' component={Deduction} />
          <PrivateRouteInternal exact path='/os/operations/general/payrollruns' component={PayrollRunList} />
          <PrivateRouteInternalWithErrorBoundary exact path='/os/operations/general/payrollruns/:payrollRunId' component={PayrollRun} />
          <PrivateRoute path='/os/operations/general/deductions' component={Deductions} />
          <PrivateRouteWithPermission exact path='/os/operations/finance/accounts' responsibility='view_accounts_global' component={Accounts} />
          <PrivateRouteWithPermission exact path='/os/operations/finance/transactions' responsibility='view_accounts_global' component={Transactions} />
          <PrivateRoute exact path='/os/operations/finance/transactions/:id' component={Transaction} />
          <PrivateRouteWithPermission exact path='/os/operations/finance/payments' responsibility='view_accounts_global' component={Payments} />
          <PrivateRoute exact path='/os/operations/finance/payments/:id' component={Payment} />
          <PrivateRoute exact path='/os/communications' component={Communications} />
          <PrivateRouteInternal exact path='/os/communications/whatsapp/:messageId' component={WhatsAppMessage} />
          <PrivateRoute exact path='/os/insights' render={() => <Redirect to='/os/insights/impact' />} />
          {/* <PrivateRoute exact path='/os/insights/impact' component={ImpactReport} /> */}
          <PrivateRouteWithPermission exact path='/os/insights/impact/:employer' responsibility='impact_report_recipient' component={ImpactReport} />
          <PrivateRouteInternal path='/os/insights/reports' component={Metrics} />
          <PrivateRouteInternal exact path='/os/search/:query' component={Search} />
          <PrivateRouteInternal exact path='/os/operations/general/workflows' component={WorkflowList} />
          <PrivateRouteInternal path='/os/operations/general/workflows/:workflowRunUUID' component={Workflow} />
          <PrivateRoute exact path='/os/dashboard' component={Dashboard} />
          <PrivateRoute exact path='/os/downloads' component={DownloadList} />
          <PrivateRoute exact path='/os/:id' component={ObjectRedirect} />
          <Route render={() => <FourOhFour pathName={this.props.location.pathname}/>} />
        </Switch>
      </div>
    )
  }
}

export default withRouter(Main)



// WEBPACK FOOTER //
// ./src/containers/Main.js